module.exports = __webpack_public_path__ + "img/logo.9389f892.png";